export { default } from '../ArcadeChestSolid/ArcadeChestSolidColor.tsx'
